import { useCallback, useEffect, useRef, useState } from "react";

export const useCounters = (time: number) => {
  const [count, setCount] = useState(time);
  const counterTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const getCurrentCount = (expireTime: number) => Math.ceil((expireTime - Date.now()) / 1000);

  const clearTimer = useCallback(() => {
    if (counterTimerRef.current) {
      clearInterval(counterTimerRef.current);
      counterTimerRef.current = null;
    }
  }, []);

  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, [clearTimer]);

  const tickTimer = useCallback(
    (expireTime: number) => {
      const remainCount = getCurrentCount(expireTime);

      setCount(remainCount);

      if (remainCount === 0) {
        clearTimer();
      }
    },
    [clearTimer]
  );

  const startCounter = useCallback(() => {
    const expireTime = Date.now() + time * 1000;

    setCount(getCurrentCount(expireTime));

    counterTimerRef.current = setInterval(() => tickTimer(expireTime), 1000);
  }, [tickTimer, time]);

  const resetTimer = useCallback(() => {
    clearTimer();
    startCounter();
  }, [clearTimer, startCounter]);

  return {
    resetTimer,
    clearTimer,
    startCounter,
    remainingTime: Math.max(count, 0),
  };
};
